import Cookies from 'js-cookie'

const state = {
    // ...其他配置项省略...
    // set locale 设置默认初始化的语言 i18n
    language: Cookies.get('language') || 'zh'
}

const mutations = {
    // ...其他配置项省略...
    SET_LANGUAGE: (state, language) => {
        state.language = language
        Cookies.set('language', language)
    }
}

const actions = {
    // ...其他配置项省略...
    setLanguage({ commit }, language) {
        commit('SET_LANGUAGE', language)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/modules/app.js